import { Image, Stack, Box,Center } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import img from "../../../assets/livestream_photo.jpeg";
import "@livekit/components-styles";
import { Track } from "livekit-client";
import {
  ControlBar,
  GridLayout,
  VideoTrack,
  LiveKitRoom,
  ParticipantTile,
  RoomAudioRenderer,
  useTracks,
} from "@livekit/components-react";
import useSmallScreen from "../../../components/useSmallScreen";
import LiveStreamBottomControls from "./components/LiveStreamBottomControls";
import LiveStreamTopControls from "./components/LiveStreamTopControls";
// import HostControls from "../components/livekit/host-controls";
import HostControls from "../../../components/livekit/host-controls";
import Chat from "../../../components/livekit/host-chat";
import StreamPlayer from "../../../components/livekit/stream-player";
import axios from "axios";
import { useGetState } from "../../../context/useGetState";
import { Hourglass, ColorRing } from 'react-loader-spinner'


function WatchStreamNow() {
  const { state } = useGetState();
  const _token = sessionStorage.getItem("#f8WEB#");
  const config = {
    headers: { Authorization: `Bearer ${_token}` }
  };
  const baseURL2 = "http://104.237.2.75/api/list";
  console.log("username", state);
  const location = useLocation();

  //livekit hard code
  const roomName = location?.state?.room;
  const username = state?.userInfo?.username;
  const url = state?.userInfo?.picture
  console.log("room,name", roomName, state);
  console.log('location view-->', location, location?.state?.streamer)

  const serverUrl = "wss://pindodg-g5szeweq.livekit.cloud";
  const [showFullScreen, setShowFullScreen] = useState(false);
  const [smallScreen] = useSmallScreen();
  const [viewingLiveStream, setViewingLiveStream] = useState(false);

  // uncomment when livekit works
  // const { state } = useLocation();
  const [token, setToken] = React.useState(null);
  useEffect(() => {
    const getOrCreateViewerToken = async () => {
      if (username && roomName) {
        const resp = await fetch(`https://livestream-ruby.vercel.app/api/watch?room=${roomName}&username=${username}&url=${url}`)

        const data = await resp.json();
        setToken(data);
        // axios.get(baseURL2,config).then((response) => {
        //   console.log()
        //   // setLivestream(response?.data);
        // });

      }



    };
    void getOrCreateViewerToken();
  }, [username]);

  // const name = 'james';





  if (token?.token === '') {
    return <Center><ColorRing
      height="80"
      width="80"
      ariaLabel="loading"

    /></Center>;
  }



  const fullScreenStyles = {
    position: "fixed",
    w: "100vw",
    h: "100vh",
    left: "0",
    right: "0",
    top: "0",
    bottom: "0",
    zIndex: "1999",
  };

  const imgSizeStyle = {
    w: "100%",
    h: !smallScreen ? "100%" : "80vh",
  };
  function MyVideoConference() {
    // `useTracks` returns all camera and screen share tracks. If a user
    // joins without a published camera track, a placeholder track is returned.
    // const tracks = useTracks(
    //   [
    //     { source: Track.Source.Camera, withPlaceholder: true },
    //     { source: Track.Source.ScreenShare, withPlaceholder: false },
    //   ],
    //   { onlySubscribed: false },
    // ); 
    const trackRefs = useTracks([Track.Source.Camera]);
    const tokyoCamTrackRef = trackRefs.find((trackRef) => trackRef?.participant?.identity === location?.state?.streamer);
    console.log('ref', tokyoCamTrackRef, state?.userInfo?.username, trackRefs)


    return (
      //@ts-ignore
      <>{tokyoCamTrackRef ? <VideoTrack style={{ height: '80%' }} trackRef={tokyoCamTrackRef} /> : <ColorRing
        height="80"
        width="80"
        ariaLabel="loading"

      />}</>

    );
  }

  return (



    <LiveKitRoom
      token={token?.token}
      audio={true}
      video={true}
      serverUrl={serverUrl}
      // Use the default LiveKit theme for nice styles.
      data-lk-theme="default"
      style={{
        height: '100vh',borderRadius:'50px'
        , backgroundColor: 'transparent'
      }}
    >
      {/* <MyVideoConference   style={{ height: '100vh' }} /> */}
      <StreamPlayer streamerIdentity={location?.state?.streamer} />
      {/* <ChannelInfo streamerIdentity={'react'} viewerIdentity={'tom'} /> */}

      <LiveStreamBottomControls
        showFullScreen={showFullScreen}
        viewingLiveStream={viewingLiveStream}
      />
      {/* <ControlBar
        style={{
          // marginTop: -100,position:'fixed', right: 0
          right: 0,
          marginTop: -90,
          marginLeft: '40%',
          bottom: '170px'
        }}
         /> */}
    </LiveKitRoom>
    

  );
}

export default WatchStreamNow;
